module.exports = __webpack_public_path__ + "static/full-logo-2493686f19cb222ed1486649dc1e4777.png";